import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { yearRegex } from "../../../../../globals.js";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";

class DevP3BpscCostForm extends Component {
  render() {
    const role = localStorage.getItem("project_role");
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        console.log("errors", errors);

        if (Object.keys(errors).length !== 0) {
            // this.props.setFieldTouched("psc_delivery_method_id", true);
            this.props.setFieldTouched("psc_start_year", true);
            this.props.setFieldTouched("psc_complete_year", true);
            this.props.setFieldTouched("psc_cost", true);
            this.props.setFieldTouched("risk_value_under_psc", true);
        } else {
          this.props.values.project_id = this.props.currentProjectID;
          func(values);
          this.props.toggleSmallModalHandler();
        }
      });
    };

    let buttonGroup = null;
    if (this.props.values.data_status_id === 1) {
      buttonGroup = (
        <Aux>
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.updateDraft, this.props.values);
            }}
          >
            Save Updates
          </Button>
          <Button
              className={"ml-2"}
              type="button"
            color="blue"
            onClick={() => {
              validAndHandle(
                this.props.methods.updateDraftAndSubmit,
                this.props.values
              );
            }}
          >
            Submit for Approval
          </Button>
            <Button type="button" onClick={this.props.handleReset} className={"ml-2"} color={"red"}
            >
                Reset
            </Button>
        </Aux>
      );
    } else if (this.props.values.data_status_id === 2) {
      if (role === "ROLE_MEMBER" || role === "ROLE_AUDITOR") {
        buttonGroup = (
            <Aux>
              <Button
                  color={"blue"}
                type="button"
                onClick={() => {
                  validAndHandle(this.props.methods.audit, this.props.values);
                }}
              >
                Audit
              </Button>
            </Aux>
        );
      }
    } else if (this.props.values.data_status_id === 3) {
      if (role === "ROLE_MEMBER") {
        buttonGroup = (
          <Button
              className={"ml-2"}
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.update, this.props.values);
            }}
          >
            Update
          </Button>
        );
      }
    } else {
      buttonGroup = (
        <Aux>
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.draft, this.props.values);
            }}
          >
            Save as Draft
          </Button>
          <Button
              color={"blue"}
              className={"ml-2"}
              type="button"
            onClick={() => {
              validAndHandle(this.props.methods.submit, this.props.values);
            }}
          >
            Submit
          </Button>
          <Button type="button" onClick={this.props.handleReset} className={"ml-2"} color={"red"}
          >
            Reset
          </Button>
        </Aux>
      );
    }

    return (
      <Form>
        <fieldset
          disabled={this.props.disabled}
        >
        <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>
          <label className="col-3 pl-2" style={this.props.errors.psc_cost && this.props.touched.psc_cost && {color: "red"}}>
            PSC Cost
            <Field
                style={this.props.errors.psc_cost && this.props.touched.psc_cost && {color: "red"}}
             className="form-control" name={"psc_cost"} value={this.props.values.psc_cost || null} />
              {this.props.errors.psc_cost && this.props.touched.psc_cost && (
                  <small className={"text-danger"}>{this.props.errors.psc_cost}</small>
              )}
          </label>
          <label className="col-3 pl-2" style={this.props.errors.risk_value_under_psc && this.props.touched.risk_value_under_psc && {color: "red"}}>
            Risk Value Under PSC
            <Field
                style={this.props.errors.risk_value_under_psc && this.props.touched.risk_value_under_psc && {color: "red"}}
                className="form-control"
              name={"risk_value_under_psc"}
              value={this.props.values.risk_value_under_psc || null}
            />
              {this.props.errors.risk_value_under_psc && this.props.touched.risk_value_under_psc && (
                  <small className={"text-danger"}>{this.props.errors.risk_value_under_psc}</small>
              )}
          </label>
          <label
              style={this.props.errors.psc_start_year && this.props.touched.psc_start_year && {color: "red"}}
              className="col-3 pl-2">
            PSC Start Year
              <Field
                  style={this.props.errors.psc_start_year && this.props.touched.psc_start_year && {borderColor: "red"}}
                className="form-control"
              name={"psc_start_year"}
              value={this.props.values.psc_start_year || null}
            />
              {this.props.errors.psc_start_year && this.props.touched.psc_start_year && (
                  <small className={"text-danger"}>{this.props.errors.psc_start_year}</small>
              )}
          </label>

          <label
              style={this.props.errors.psc_complete_year && this.props.touched.psc_complete_year && {color: "red"}}
              className="col-3 pl-2">
            PSC Complete Year
              <Field
                  style={this.props.errors.psc_complete_year && this.props.touched.psc_complete_year && {borderColor: "red"}}
    className="form-control"
              name={"psc_complete_year"}
              value={this.props.values.psc_complete_year || null}
            />
              {this.props.errors.psc_complete_year && this.props.touched.psc_complete_year && (
                  <small className={"text-danger"}>{this.props.errors.psc_complete_year}</small>
              )}
          </label>

          <label className="col-3 pl-2">
            Public Upfront Contribution Under PSC
            <Field
    className="form-control"
              name={"public_upfront_contribution_under_psc"}
              value={
                this.props.values.public_upfront_contribution_under_psc || ""
              }
            />
          </label>
                <SelectionFields
                    size={"col-3 pl-2"}
                    id={"psc_delivery_method_id"}
                    url={"psc_delivery_method_lkp"}
                    showElem={"name"}
                    label={"PSC Delivery Method"}
                    value={this.props.values["psc_delivery_method_id"] || "default"}
                    isRequired={false}
                />

                {/*{this.props.errors.psc_delivery_method_id && this.props.touched.psc_delivery_method_id && (*/}
                    {/*<span className={classes.Error}>{this.props.errors.psc_delivery_method_id}</span>*/}
                {/*)}*/}
          <label className="col-6 pl-2 d-block">
            Notes
            <Field
                component={"textarea"}
                className="form-control" name={"notes"} value={this.props.values.notes || ""} />
          </label>
        </fieldset>

        {buttonGroup}
        <Button type="button" onClick={this.props.toggleSmallModalHandler} className={"ml-2"}>
          Cancel
        </Button>
      </Form>
    );
  }
}

var devP3BpscCostFormSchema = Yup.object().shape({
    // psc_delivery_method_id: Yup.string().required(),
    psc_start_year: Yup.string().nullable().matches(yearRegex, "Invalid year").typeError("Must be a year type"),
    psc_complete_year: Yup.string().nullable().matches(yearRegex, "Invalid year").typeError("Must be a year type"),
    psc_cost: Yup.number().nullable().typeError("Number required"),
    risk_value_under_psc: Yup.number().nullable().typeError("Number required"),
});

export default withFormik({
  validationSchema: devP3BpscCostFormSchema,

  mapPropsToValues({ currentDevP3BpscCost }) {
    return {
      ...currentDevP3BpscCost
    };
  }
})(DevP3BpscCostForm);
